import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { getTag } from 'selectors';

class RecommendationLocation extends Component {
  render() {
    const { city, province } = this.props;
    return (
      <span className="Recommendation-location">
        {city.name}, {province.name}
      </span>
    );
  }
}

RecommendationLocation.propTypes = {
  recommendation: PropTypes.object.isRequired,
};

function mapStateToProps(state, props) {
  const university = getTag(state, props.recommendation.program.university);
  return {
    university,
    city: getTag(state, university.city),
    province: getTag(state, university.province),
  };
}

export default connect(mapStateToProps)(RecommendationLocation);




// WEBPACK FOOTER //
// ./src/Components/Pages/Results/Recommendations/RecommendationLocation.js